import { Link } from 'react-router-dom';
import { IllustrationView } from 'modules/shared/features/illustration';
import { useState } from 'react';
import useAuthSelector from 'modules/shared/hooks/useAuthSelector';

const Page = () => {
    const { expiryInMinutes } = useAuthSelector();

    const [activityPeriod] = useState(expiryInMinutes ? '30 days' : '30 minutes'); // Store rememberMe in state as to avoid rememberMe value change after logout.

    return (
        <IllustrationView
            className="mt-[32vh]"
            illustration={<img className="h-10" src="/logos/logo.svg" alt="" />}
            title="You have been signed out"
            message={
                <>
                    There has been no activity on your account for the past {activityPeriod}. <br />
                    Please sign in again to continue using your account.
                    <div className="mt-4">
                        <Link to="/" replace className="text-primary font-medium cursor-pointer">
                            Sign in
                        </Link>
                    </div>
                </>
            }
        />
    );
};

export default Page;
